import React from 'react'
import { Pagination } from 'react-bootstrap'

const PaginationComp = ({ postsPerPage, totalPosts, setCurrentPage }) => {
    const pageNumbers = [];
    const [active, setActive] = React.useState(1)

    for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
        pageNumbers.push(i)
    }
    return (
        <Pagination>
            { pageNumbers.map(number => (
                <Pagination.Item onClick={() => {setCurrentPage(number);window.scrollTo({ top: 0 });setActive(number)}} active={number === active} key={number} style={{cursor:"pointer"}}>
                    {number}
                </Pagination.Item>
            ))}
        </Pagination>
    )
}

export default PaginationComp
